function isApprovedRedirect(url) {
  const REDIRECT_WHITELIST = [
    global.config.LIC_CUSTOMER_ENDPOINT,
    'http://localhost:5012',
  ]
  return REDIRECT_WHITELIST.includes(new URL(url).origin)
}

export default isApprovedRedirect
